import { useSelector } from 'react-redux';


const useProducts = (storeCode) => {
  return useSelector(
    (state: IReduxState) => ({
      allStoreProducts: state.products.store_products.catalogProducts,
      activeProducts: state.products.store_products.catalogProducts?.filter((pr) => pr.status === 1),
      disabledProducts: state.products.store_products.catalogProducts?.filter((pr) => pr.status !== 1),
      queueTasks: state.products.queueTasks[storeCode] || [],
      queueTasksSkus: state.products.queueTasksSkus[storeCode] || [],
      productsLoading: state.products.productsLoading,
      error: state.products.error,
      deletingProduct: state.products.deletingProduct,
      allQuoteProducts: state.quote.quoteProducts,
      activeQuoteProducts: state.quote.quoteProducts.filter((pr) => pr.status === 1),
      disabledQuoteProducts: state.quote.quoteProducts.filter((pr) => pr.status !== 1),
      quoteProductsLoading: state.quote.quoteProductsLoading
    }));
};

export default useProducts;
